module.exports = __webpack_public_path__ + "static/media/website-15.3dda71ba.png";